
export default (function (change) {
  window.scrollBy(change.x, change.y);
});